import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";

const useStylesBase = makeStyles(styles);

const stylesCenter = {
  center: {
    textAlign: "center",
  },
};

const stylesSize = {
  size: {
    fontSize: "large",
    color: "black",
    opacity: 1,
    textAlign: "left",
  },
};

const styleHeading = {
  heading: {
    fontWeight: "bold",
    textAlign: "center",
  },
};

const stylesList = {
  list: {
    padding: 0,
    textAlign: "center",
    listStyle: "inside",
    fontSize: "large",
  },
};

const useStylesCenter = makeStyles(stylesCenter);
const useStylesSize = makeStyles(stylesSize);
const useStylesList = makeStyles(stylesList);
const useStylesHeading = makeStyles(styleHeading);

export default function Mission() {
  const classesBase = useStylesBase();
  const classesList = useStylesList();
  const classesSize = useStylesSize();
  const classesCenter = useStylesCenter();
  const classesHeading = useStylesHeading();

  const classes = {
    ...classesBase,
    ...classesSize,
    ...classesList,
    ...classesCenter,
    ...classesHeading,
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card profile>
          <CardBody profile>
            <div className={classes.size}>
              <h3 className={classes.heading}>
                PREVENT Group (Pediatric REspiratory and VENTilation Group)
              </h3>
              <div>
                <br></br>
                <h4 className={classes.heading}>Mission Statement</h4>

                <h5 className={classes.center}>
                  To improve outcomes in critically ill children by supporting
                  and performing research in respiratory diseases and mechanical
                  ventilation strategies.
                </h5>
                <br></br>
                <h4 className={classes.heading}>Goals of PREVENT</h4>

                <h5 className={classes.center}>
                  Facilitate multi-center collaborative research in respiratory
                  diseases and mechanical ventilation:
                </h5>
                <ul className={classes.list}>
                  <li>Feedback on early stage projects (even single center)</li>
                  <li>
                    Cultivate investigators interested in research in
                    respiratory diseases and mechanical ventilation
                  </li>
                  <li>
                    Development and testing of explicit protocols related to
                    mechanical ventilation
                  </li>
                  <li>
                    Framework to mature research ideas and provide scientific
                    oversight
                  </li>
                </ul>
              </div>
            </div>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
